import { createAction, props, union } from '@ngrx/store';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';
// import { KeyValue } from '@angular/common';

export const showProgressBar = createAction(
  '[StpState] Show Progress Bar',
  props<{ isDisplayProgressBar: boolean}>()
);

export const updatePolicyChangeDate = createAction(
  '[StpState] Update Policy Date',
  props<{ policyChangeDate: Date }>()
);

export const updatePolicyQuoteRetrievedStatus = createAction(
  '[StpState] Update Policy Quote Retrieved Status',
  props<{ isQuoteRetrieved: boolean }>()
);

export const updatePolicyChangeType = createAction(
  '[StpState] Update Policy Change Type',
  props<{ changeType: string }>()
);

export const updatePolicyChangeOptions = createAction(
  '[StpState] Update Policy Change Options',
  props<{ options: KeyValueDict<boolean>}>()
);

export const postalAdressStatus = createAction(
  '[StpState] Update Postal address status',
  props<{ isYourPostalAdressSelected: boolean }>()
);

export const policyAdressStatus = createAction(
  '[StpState] Update Policy address status',
  props<{ isYourPolicyAdressSelected: boolean }>()
);

/*export const updateBanDate = createAction(
  '[StpState] Update Ban Date',
  props<{ ban: KeyValue<string, string[]> }>()
);*/

export const removeBanDate = createAction(
  '[StpState] Remove Ban Date',
  props<{ driverId: string}>()
);

export const updateQuotedStatus = createAction(
  '[StpState] Update Quoted Status'
);

export const updateTempChangeEndDate = createAction(
  '[Policy] Update Temp Change Duration',
  props<{endDate: Date}>()
);

export const clearStore = createAction(
  '[StpState] Clear Store'
);

const all = union({
  showProgressBar,
  updatePolicyChangeDate,
  updatePolicyChangeType,
  updatePolicyChangeOptions,
  // updateBanDate,
  removeBanDate,
  updateQuotedStatus,
  updateTempChangeEndDate,
  clearStore
});

export type StpActionsUnion = typeof all;
